import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e836f860"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "duplicate-modal" }
const _hoisted_2 = { class: "duplicate-group__header" }
const _hoisted_3 = { class: "duplicate-group__file has-text-weight-semibold" }

import { ArrowDown, ArrowRight, Delete } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { PropType, ref, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import CustomModal from '@/components/CustomModal.vue';
import SimilarAnalysesList from '@/components/SimilarAnalysesList.vue';
import { DuplicateWarning, useSimilarAnalysesStore } from '@/stores/similar-analyses.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'DuplicateDecisionModal',
  props: {
    warnings: {
        type: Array as PropType<DuplicateWarning[]>,
        required: true,
    },
},
  emits: ['close', 'delete'],
  setup(__props, { emit }) {

const props = __props;





const { warnings } = toRefs(props);

const { t } = useI18n();
const similarAnalysesStore = useSimilarAnalysesStore();

const expandedId = ref<string | null>(null);

const toggle = (warning: DuplicateWarning): void => {
    if (expandedId.value === warning.uploadedAnalysisId) {
        expandedId.value = null;
        similarAnalysesStore.clearSimilar();
    } else {
        expandedId.value = warning.uploadedAnalysisId;
        similarAnalysesStore.showSimilar(warning.similar);
    }
};
const checkWarningsAfterDelete = (analysisId: string): void => {
    emit('delete', analysisId);
    if (!similarAnalysesStore.hasWarnings) {
        emit('close');
    }
};
const deleteAnalysis = async (analysisId: string): Promise<void> => {
    try {
        await ElMessageBox.confirm(t('analysis.deleteConfirmMessage'), t('analysis.deleteConfirmTitle'), {
            type: 'warning',
            confirmButtonText: t('common.yes'),
            cancelButtonText: t('common.no'),
        });
        try {
            await similarAnalysesStore.deleteAnalysis(analysisId);
            ElMessage.success(t('analysis.deleteConfirmed'));
            checkWarningsAfterDelete(analysisId);
        } catch (error) {
            const { message } = error as { message: string };
            ElMessage.error(message);
        }
    } catch {
        ElMessage.info(t('analysis.deleteCanceled'));
    }
};

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(CustomModal, {
    width: "680px",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    "modal-header": _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('duplicateDecision.title')), 1)
    ]),
    "modal-footer": _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        class: "button is-radius-small has-text-weight-semibold",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('common.close')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_alert, {
          title: _unref(t)('duplicateDecision.warning'),
          type: "warning",
          closable: false,
          "show-icon": ""
        }, null, 8, ["title"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(warnings), (warning) => {
          return (_openBlock(), _createElementBlock("div", {
            key: warning.uploadedAnalysisId,
            class: "duplicate-group"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(warning.fileName), 1),
              _createVNode(_component_el_button, {
                size: "small",
                type: "danger",
                icon: _unref(Delete),
                onClick: ($event: any) => (deleteAnalysis(warning.uploadedAnalysisId))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('duplicateDecision.deleteUpload')), 1)
                ]),
                _: 2
              }, 1032, ["icon", "onClick"])
            ]),
            _createVNode(_component_el_button, {
              text: "",
              type: "primary",
              size: "small",
              icon: expandedId.value === warning.uploadedAnalysisId ? _unref(ArrowDown) : _unref(ArrowRight),
              onClick: ($event: any) => (toggle(warning))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('duplicateDecision.viewSimilar', { count: warning.similar.length })), 1)
              ]),
              _: 2
            }, 1032, ["icon", "onClick"]),
            (expandedId.value === warning.uploadedAnalysisId)
              ? (_openBlock(), _createBlock(SimilarAnalysesList, {
                  key: 0,
                  class: "mt-2",
                  onDelete: _cache[0] || (_cache[0] = ($event: any) => (checkWarningsAfterDelete($event)))
                }))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})